import React from 'react';
import { Link } from 'react-router-dom';
import { AiFillHome } from 'react-icons/ai';
import { IoIosArrowForward } from 'react-icons/io';
import { p } from 'framer-motion/client';

const Breadcrumbs = ({ items }) => {
    return (
        <div className="flex gap-3 items-center font-medium text-gray-500 text-xs">
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    {/* Render home icon for the first breadcrumb */}
                    {index === 0 && <AiFillHome />}
                    {item.link ?
                        <Link
                            to={item.link}
                            className="hover:underline hover:text-primary"
                        >
                            {item.name}
                        </Link> :
                        <p className='cursor-not-allowed'>
                            {item.name}
                        </p>
                    }
                    {/* Show arrow except for the last breadcrumb */}
                    {index < items.length - 1 && <IoIosArrowForward />}
                </React.Fragment>
            ))}
        </div>
    );
};

export default Breadcrumbs;
